import React from 'react';
import { PALMISTRY_PRICE_LABEL } from '../../data/palmistry101Content';
import PalmistryPrimaryCta from './PalmistryPrimaryCta';

export default function PalmistryCTA({ checkoutUrl, onCta }) {
  const hasCheckout = Boolean(checkoutUrl);

  return (
    <section
      className="amm-palmistry101-section amm-palmistry101-cta-block"
      id="palmistry-purchase"
      aria-labelledby="palmistry-cta-heading"
    >
      <div className="amm-palmistry101-cta-card">
        <h2 id="palmistry-cta-heading" className="amm-palmistry101-cta-title">
          Palmistry 101
        </h2>
        <p className="amm-palmistry101-cta-price">{PALMISTRY_PRICE_LABEL}</p>
        <p className="amm-palmistry101-cta-copy">
          Interactive lesson page plus printable companion PDF · self-paced · access when your checkout
          connection is live.
        </p>
        <p className="amm-palmistry101-cta-soft">
          Start with the hand you already have — and learn to read it with more clarity.
        </p>

        <PalmistryPrimaryCta checkoutUrl={checkoutUrl} onFallback={onCta} className="amm-palmistry101-cta-btn" />

        {!hasCheckout && (
          <div className="amm-palmistry101-cta-fallback">
            <p>
              When checkout is configured in your hosting environment, the button above will open your
              payment page directly. Until then, you can continue with the preview on this page — nothing here
              is rushed.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
